import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import MEModal from '../../components/MEModal'

const SaveModal = props => {
  return (
    <MEModal
      show={props.modalOpen}
      close={props.openCloseModal}
      title="Save Order"
    >
      <p>
        Are you sure you want to save the order of the groups and their
        contained activities? This may take some time.
      </p>
      <div className="text-center mb-4">
        <Button
          type="button"
          bsStyle="primary"
          className="btn-myed btn-primary-myed mr-5"
          onClick={props.submitNewGroupActOrder}
        >
          Save
        </Button>
        <Button
          type="button"
          bsStyle="default"
          className="btn-myed btn-default-myed"
          onClick={props.openCloseModal}
        >
          Cancel
        </Button>
      </div>
    </MEModal>
  )
}

export default SaveModal

SaveModal.propTypes = {
  modalOpen: PropTypes.bool,
  openCloseModal: PropTypes.func,
  submitNewGroupActOrder: PropTypes.func,
}
